<template>
  <div class="absolute overflow-hidden transition-height" :style="style">
    <div ref="contentArea">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "CoreExpand",

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    style() {
      const {
        open,
        _isMounted,
        $refs: { contentArea }
      } = this;

      if (!open || !_isMounted) {
        return {
          height: "0px"
        };
      }

      return {
        height: `${contentArea.offsetHeight}px`
      };
    }
  }
};
</script>

<style scoped>
.transition-height {
  transition-property: height;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease-out);
}
</style>
